import React, {useEffect, useState} from 'react';
import {useTheme} from "@mui/material/styles";
import { CircularProgress, Divider, Grid, Stack, Typography, useMediaQuery} from "@mui/material";
import AuthCardWrapper from "../AuthCardWrapper";
import {Link, useParams} from "react-router-dom";
import * as api from "../../../assets/api/index";
import VerifiedIcon from '@mui/icons-material/Verified';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

function EmailVerification() {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const token = useParams();

    const [loading, setLoading] = useState(true);
    const [verified, setVerified] = useState(false)

    const sendVerification = async () => {
        
        try {
            setLoading(true)
            const formData = {
                token : String(token.token)
            }
            const { data } = await api.verifyAccount(formData);
            if(data.status === "success"){
                setLoading(false)
                setVerified(true)
            }

        } catch (err: any) {
            setLoading(false)
            setVerified(false)
        }
    }

    useEffect(()=> {
        sendVerification()
    },[])

    return (
        <Grid className="container">
            <Grid container direction="column" justifyContent="center" alignItems="center">
                <AuthCardWrapper>
                    <Grid container spacing={2} alignItems="center" justifyContent="center">
                    <Grid item container spacing={2} sx={{mb: 1}} alignItems="center" justifyContent="center">
                            <Grid item>
                                <img
                                    // height="65"
                                    width="160"
                                    src={require("../../../assets/images/logo-with-name.png")}
                                    alt="logo"/>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid
                                container
                                direction={matchDownSM ? 'column-reverse' : 'row'}
                                alignItems="center"
                                justifyContent="center">
                                <Grid item>
                                    <Stack alignItems="center" justifyContent="center" spacing={1}>
                                        <Typography
                                            color={theme.palette.primary.main}
                                            gutterBottom
                                            variant={matchDownSM ? 'h3' : 'h2'}
                                        >
                                            Account Verification
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            fontSize="16px"
                                            textAlign={matchDownSM ? 'center' : 'inherit'}
                                        >
                                           {loading ? "Verifying your account" : verified ? "Your account verified" : "Your account verification failed"}
                                        </Typography>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Stack alignItems={'center'}>
                                {loading ? <CircularProgress /> : verified ? <VerifiedIcon fontSize={"large"} color='success' /> : <NewReleasesIcon fontSize={"large"} color='error' /> }
                            </Stack>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <Grid item>
                            <Grid item container direction="column" alignItems="center" xs={12}>
                                <Typography
                                    component={Link}
                                    to="/login"
                                    variant="subtitle1"
                                    sx={{textDecoration: 'none'}}
                                >
                                    Back to login
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </AuthCardWrapper>
            </Grid>
        </Grid>
    );
}

export default EmailVerification;